import React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { LoginForm, LanguageSelect, StoreButtons } from "C4";

import Logo from 'assets/images/logo/logo_dark.png';
import CompanyLogo from 'assets/images/companylogo.png';


const LoginView = props => (
  <div className="loginView">
    <div className="loginView__bg">
      <div className="loginView__bg--content">
        <img src={CompanyLogo} alt="Company Logo" />
        <h3>{i18n.translate('loginScreen.title')}</h3>
        <div className="buttonWrapper">
          <StoreButtons />
        </div>
      </div>
    </div>
    <div className="loginView__content">
      <img src={Logo} className="loginView__content--logo" alt="Logo" />
      <LoginForm path={props.match.path} />
    </div>
  </div>
);

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
};
